<template>
  <datepicker
    calendar-button-icon="ion ion-md-calendar"
    :calendar-button="true"
    :bootstrapStyling="true"
    :format="format"
    :disabled="disabled"
    :minimumView="minimumView"
    :maximumView="maximumView"
    :disabled-dates="disabledDates"
    v-model="componentInput"
  />
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import util from '@/util';

export default {
  components: {
    Datepicker
  },
  props: {
    value: {
      type: Date
    },
    disabled: {
      type: Boolean
    },
    isRequired: {
      type: Boolean
    },
    minimumView: {
      type: String
    },
    maximumView: {
      type: String
    },
    format: {
      type: String,
      default: util.getDateFormat()
    },
    disabledDates: {
      type: Object
    }
  },
  data() {
    return {
      componentInput: ''
    };
  },

  created() {
    this.componentInput = this.value; // Multiply by 100 only because the mask
  },

  watch: {
    componentInput(val) {
      this.$emit('onChange', val);
    },
    value(val) {
      this.componentInput = val;
    }
  }
};
</script>
<style>
.form-control[readonly] {
  background-color: #fff !important;
}
.form-control[disabled] {
  background-color: #f1f1f2 !important;
}
</style>
